import DestinationCard from "./DestinationCard";

export default function DestinationGrid({ destinations }) {
  return (
    <div className="destinations-grid">
      {destinations.map((destination) => (
        <DestinationCard key={destination.slug} destination={destination} />
      ))}
    </div>
  );
}
